<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  /** Currently selected month in "yyyy-MM" format. */
  modelValue: string;
}

interface Emits {
  (e: 'update:modelValue', value: string): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();

/**
 * Build a list of the last 13 months (current + 12 prior) for the select options.
 */
const monthOptions = computed(() => {
  const now = new Date();
  const options: { value: string; label: string }[] = [];
  for (let i = 0; i <= 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const value = `${yyyy}-${mm}`;
    const label = d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    options.push({ value, label });
  }
  return options;
});
</script>

<template>
  <div class="flex items-center gap-2" data-testid="month-picker">
    <label
      for="month-picker-select"
      class="text-caption font-medium text-muted uppercase tracking-wide whitespace-nowrap"
    >
      Reporting period
    </label>
    <select
      id="month-picker-select"
      :value="modelValue"
      class="h-9 rounded-md border border-border bg-surface px-3 text-sm text-fg focus:outline-none focus-visible:ring-2 focus-visible:ring-navy-600"
      @change="emit('update:modelValue', ($event.target as HTMLSelectElement).value)"
    >
      <option v-for="opt in monthOptions" :key="opt.value" :value="opt.value">
        {{ opt.label }}
      </option>
    </select>
  </div>
</template>
